// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"269":"792f855e","365":"792f855e"}[chunkId] + ".chunk.css";
};